import { render } from "./ContentFileListModalPress.vue?vue&type=template&id=2b3b848a"
import script from "./ContentFileListModalPress.vue?vue&type=script&lang=js"
export * from "./ContentFileListModalPress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__